import { render, staticRenderFns } from "./globalBackground.vue?vue&type=template&id=7c51a6d0"
import script from "./globalBackground.vue?vue&type=script&lang=js"
export * from "./globalBackground.vue?vue&type=script&lang=js"
import style0 from "./globalBackground.vue?vue&type=style&index=0&id=7c51a6d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports